// extracted by mini-css-extract-plugin
module.exports = {"paginationRow":"Paginate_paginationRow__3YvwF","pageSize":"Paginate_pageSize__3WeAv"};